/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://ds5ubdk5rndqbmxdap5qq4d2qm.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-bden2tu3vzga3kzk2xd43cfvnm",
    "aws_cognito_identity_pool_id": "eu-west-2:616ab0a4-5ef9-4e41-9ded-7eed67254919",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_kjsuXmz9A",
    "aws_user_pools_web_client_id": "1htq3eleovm48iggq3ug9ci0mb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
